import { forwardRef, useImperativeHandle, useRef } from "react";

export const SearchBar = forwardRef((props, ref) => {
  const { handleSearch, placeholder } = props;
  const inputRef = useRef(null);

  useImperativeHandle(
    ref,
    () => ({
      reset: () => {
        inputRef.current.value = "";
      },
    }),
    [ref]
  );

  return (
    <input
      ref={inputRef}
      type="search"
      onChange={handleSearch}
      placeholder={placeholder}
      className="w-full rounded-md bg-white py-1.5 pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500 sm:text-sm/6"
    />
  );
});
